export enum EventPlatform {
    GoogleMeet = "Google Meet",
    Discord = "Discord",
    Custom = "Personalizado",
}